import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { AppDoubleMatSlideToggleComponent } from "./components";

@NgModule({
  declarations: [AppDoubleMatSlideToggleComponent],
  imports: [CommonModule, MatSlideToggleModule],
  exports: [AppDoubleMatSlideToggleComponent]
})
export class AppDoubleMatSlideToggleModule {}
